export default __webpack_public_path__ + "static/media/faqArrowDown.680ee3df.svg";